export abstract class Geometry {
  public type: GeometryType;
  public abstract getPoints(): Point[];
}

export class MapLocation {
  public geometry: Geometry;
  public zoomLevel: number;
}

export class BboxGeometry extends Geometry {
  public ne: Point;
  public sw: Point;
  public center: Point;

  constructor() {
    super();
    this.type = GeometryType.bbox;
  }

  public getPoints(): Point[] {
    return [this.ne, this.sw];
  }

  public getCenter(): Point {
    return this.center;
  }
}

export class Point {
  public lat: number;
  public lng: number;

  constructor(lat: number, lng: number) {
    this.lat = lat;
    this.lng = lng;
  }
}

export enum GeometryType {
  point = 1,
  bbox = 2
}
